import ContentLoader from 'react-content-loader';

const PhotoSkeleton = () => {
  return (
    <ContentLoader
      speed={1}
      width="100%"
      height="calc(80vh + 170px)"
      backgroundColor="#1f222d"
      foregroundColor="#2b2f3b"
      style={{
        display: 'block',
        overflow: 'hidden'
      }}
    >
      <rect x="0" y="0" rx="0" ry="0" width="100%" height="80vh" />

      <rect
        x="10"
        y="calc(80vh + 10px)"
        rx="12px"
        ry="12px"
        width="calc(100% - 20px)"
        height="70px"
      />
    </ContentLoader>
  );
};

export default PhotoSkeleton;
